<template>
  <div>
    <img
      class
      src="../assets/logo1.jpeg"
      style="border-radius: 50px; background: white none repeat scroll 0% 0%;"
      alt
      width="100"
      height="100"
    />
    <img
      class
      src="../assets/logo2.jpeg"
      style="border-radius: 50px; background: white none repeat scroll 0% 0%;"
      alt
      width="100"
      height="100"
    />
    <h1 class="h3 mb-2 font-weight-normal">Please sign in</h1>
    <div class="alert alert-info">You will be redirected to after you login.</div>
    <div class="alert alert-warning" v-if="error">{{error}}</div>
    <div>
      <button class="btn white black-text large" @click="gmail">
        <img
          width="24px"
          style="margin-bottom:3px; margin-right:5px"
          alt="Google sign-in"
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/512px-Google_%22G%22_Logo.svg.png"
        /> Login with Google
      </button>
    </div>
    <div class="my-2">
      <button class="btn blue darken-4 white-text large" @click="fb">
        <i class="fa fa-facebook fa-fw" style="color:white"></i> Login with Facebook
      </button>
    </div>
    <div class="my-5">
      <div
        class="fb-page"
        data-href="https://www.facebook.com/C2CVoice/"
        data-tabs="timeline"
        data-width
        data-height
        data-small-header="false"
        data-adapt-container-width="true"
        data-hide-cover="false"
        data-show-facepile="true"
      >
        <blockquote cite="https://www.facebook.com/C2CVoice/" class="fb-xfbml-parse-ignore">
          <a href="https://www.facebook.com/C2CVoice/">Campus 2 Community</a>
        </blockquote>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  data() {
    return {
      error: "",
    };
  },
  methods: {
    gmail() {
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithRedirect(provider);
    },
    fb() {
      var provider = new firebase.auth.FacebookAuthProvider();
      firebase.auth().signInWithRedirect(provider);
    },
  },
  created() {
    console.log("Hi");
    firebase
      .auth()
      .getRedirectResult()
      .then((result) => {
        if (result.credential) {
          console.log(result);
          // This gives you a Google Access Token. You can use it to access the Google API.
          var token = result.credential.accessToken;
          // ...
        }
        // The signed-in user info.
        if (result.user != null) {
          //this.$router.push({ name: "Aboutme" });
        }
        var user = result.user;
        console.log(result);
      })
      .catch((error) => {
        console.log(error);
        this.error = "Please login to access the website.";
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        console.log(user);
        if (user.displayName != null) {
          console.log(user.email);
          this.$store.state.email = user.email;
          console.log(this.$store.state.email);
          this.$router.push({ name: "Aboutme" });
        }
      } else {
        // No user is signed in.
        console.log("USER NOT LOGGED IN");
      }
    });
  },
  mounted() {},
};
</script>

<style>
</style>